import UsersReducer from './reducers';

const usersReducers = {
  allUsers: UsersReducer.allUsersReducer,
  specificUser: UsersReducer.specificUsersReducer,
};

export { usersReducers };
